export const mails: TableModule = {
    name: "mails",
    route: "spa.mails",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "recipient",
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: "subject",
            sortable: true,
            mobile: true,
            width: "w-1/3"
        },
        {
            name: "status",
            sortable: true,
            width: "w-[150px]",
            mobile: true
        },
        {
            name: "created_at",
            width: "w-[150px]",
            sortable: true,
        }
    ],
    filters: [
        {
            name: "id",
            column: "mails.id",
            type: "numeric"
        },
        {
            name: "recipient",
            column: "mails.recipient",
            type: "string",
            reduced: true
        },
        {
            name: "subject",
            column: "mails.subject",
            type: "string",
            reduced: true
        },
        {
            name: "status",
            column: "mails.status",
            type: "select",
            options: () => [
                { value: 'pending', label: useNuxtApp().$i18n.t('mails.statuses.pending') },
                { value: 'sent', label: useNuxtApp().$i18n.t('mails.statuses.sent') },
                { value: 'delivered', label: useNuxtApp().$i18n.t('mails.statuses.delivered') },
                { value: 'failed', label: useNuxtApp().$i18n.t('mails.statuses.failed') }
            ]
        },
        {
            name: "created_at",
            column: "mails.created_at",
            type: "date"
        }
    ],
}